const OPENABLE_QR_PROTOCOLS = new Set([
  "http:",
  "https:",
  "mailto:",
  "tel:",
  "sms:",
  "geo:",
]);

/**
 * Returns a safe, user-openable QR target. Unknown/custom schemes and
 * non-links are still valid QR content, but are shown as text instead.
 */
export const getOpenableQrUrl = (value: string): string | null => {
  try {
    const url = new URL(value);
    return OPENABLE_QR_PROTOCOLS.has(url.protocol) ? value : null;
  } catch {
    return null;
  }
};

export const copyQrValue = async (value: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand("copy");
    textarea.remove();
    return copied;
  }
};
